import { VBottomSheet } from 'vuetify/lib/components/VBottomSheet';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VTextField } from 'vuetify/lib/components/VTextField';
import Ripple from 'vuetify/lib/directives/ripple';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container" },
    [
      _c(
        VCard,
        [
          _c(VCardTitle, [
            _vm._v(
              _vm._s(_vm.$vuetify.lang.t("$vuetify.inventory.inventorySearch"))
            ),
          ]),
          _c(
            VCardText,
            [
              _c(
                "div",
                {
                  staticClass: "d-flex flex-column flex-md-row justify-center",
                },
                [
                  _vm.searchMethod == "location"
                    ? _c(VSelect, {
                        attrs: {
                          label: _vm.$vuetify.lang.t(
                            "$vuetify.worksheet.chooseLocation"
                          ),
                          placeholder: "Choose a location to start search",
                          items: _vm.locations,
                          "item-text": "name",
                          "item-value": "id",
                          clearable: "",
                        },
                        on: { "click:clear": _vm.clearSearch },
                        model: {
                          value: _vm.locationId,
                          callback: function ($$v) {
                            _vm.locationId = $$v
                          },
                          expression: "locationId",
                        },
                      })
                    : _c(VTextField, {
                        attrs: {
                          label: _vm.searchLabel,
                          placeholder: _vm.searchPlaceholder,
                          hint: _vm.$vuetify.lang.t(
                            "$vuetify.base.weightToleranceHint"
                          ),
                          "persistent-hint": "",
                          clearable: "",
                        },
                        on: {
                          keypress: function ($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            )
                              return null
                            return _vm.search.apply(null, arguments)
                          },
                          "click:clear": _vm.clearSearch,
                        },
                        model: {
                          value: _vm.searchTerm,
                          callback: function ($$v) {
                            _vm.searchTerm = $$v
                          },
                          expression: "searchTerm",
                        },
                      }),
                  _c(
                    VBtn,
                    {
                      staticClass: "ml-0 ml-md-5 mt-3",
                      on: { click: _vm.search },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(_vm.$vuetify.lang.t("$vuetify.base.search")) +
                          " "
                      ),
                    ]
                  ),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "d-flex flex-wrap justify-center mt-2" },
                [
                  _c(
                    VChip,
                    {
                      staticClass: "mr-2 mb-2",
                      attrs: {
                        small: "",
                        color: _vm.availableOnly ? "primary" : "",
                        outlined: !_vm.availableOnly,
                      },
                      on: {
                        click: function ($event) {
                          _vm.availableOnly = !_vm.availableOnly
                          if (_vm.searchMethod != "location") _vm.search()
                        },
                      },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.$vuetify.lang.t("$vuetify.base.availableOnly")
                          ) +
                          " "
                      ),
                    ]
                  ),
                  _c(
                    VChip,
                    {
                      staticClass: "mr-2 mb-2",
                      attrs: {
                        small: "",
                        color:
                          _vm.searchMethod == "documentId" ? "primary" : "",
                        outlined: _vm.searchMethod != "documentId",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.setSearchMethod("documentId")
                        },
                      },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.$vuetify.lang.t(
                              "$vuetify.base.searchByDocument"
                            )
                          ) +
                          " "
                      ),
                    ]
                  ),
                  _c(
                    VChip,
                    {
                      staticClass: "mr-2 mb-2",
                      attrs: {
                        small: "",
                        color:
                          _vm.searchMethod == "productName" ? "primary" : "",
                        outlined: _vm.searchMethod != "productName",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.setSearchMethod("productName")
                        },
                      },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.$vuetify.lang.t(
                              "$vuetify.base.searchByProductName"
                            )
                          ) +
                          " "
                      ),
                    ]
                  ),
                  _c(
                    VChip,
                    {
                      staticClass: "mr-2 mb-2",
                      attrs: {
                        small: "",
                        color: _vm.searchMethod == "weight" ? "primary" : "",
                        outlined: _vm.searchMethod != "weight",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.setSearchMethod("weight")
                        },
                      },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.$vuetify.lang.t("$vuetify.base.searchByWeight")
                          ) +
                          " "
                      ),
                    ]
                  ),
                  _c(
                    VChip,
                    {
                      staticClass: "mr-2 mb-2",
                      attrs: {
                        small: "",
                        color: _vm.searchMethod == "id" ? "primary" : "",
                        outlined: _vm.searchMethod != "id",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.setSearchMethod("id")
                        },
                      },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.$vuetify.lang.t("$vuetify.base.searchById")
                          ) +
                          " "
                      ),
                    ]
                  ),
                  _c(
                    VChip,
                    {
                      staticClass: "mr-2 mb-2",
                      attrs: {
                        small: "",
                        color: _vm.searchMethod == "location" ? "primary" : "",
                        outlined: _vm.searchMethod != "location",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.setSearchMethod("location")
                        },
                      },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.$vuetify.lang.t("$vuetify.worksheet.location")
                          ) +
                          " "
                      ),
                    ]
                  ),
                ],
                1
              ),
              _c("div", { staticClass: "text-caption text-center ma-6" }, [
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.$vuetify.lang.t(
                        "$vuetify.label.foundX",
                        _vm.totalSizes ? _vm.totalSizes : 0
                      )
                    ) +
                    " "
                ),
              ]),
              _vm.searchMethod == "location" &&
              _vm.locationSummary &&
              _vm.locationSummary.length > 0
                ? _c(
                    "div",
                    { staticClass: "my-5" },
                    [
                      _c("div", { staticClass: "text-caption mb-2" }, [
                        _vm._v("Location Summary:"),
                      ]),
                      _vm._l(_vm.locationSummary, function (product) {
                        return _c(
                          VRow,
                          {
                            key: product.productId,
                            staticClass: "d-flex justify-start",
                            attrs: { "no-gutters": "" },
                          },
                          [
                            _c(VCol, [
                              _vm._v(_vm._s(product.productName) + " "),
                            ]),
                            _c(VCol, [
                              _vm._v(
                                " " +
                                  _vm._s(product.unitAvailable) +
                                  " " +
                                  _vm._s(
                                    product.productInfo
                                      ? product.productInfo.measureUnit
                                      : ""
                                  ) +
                                  " "
                              ),
                            ]),
                            _c(VCol, { staticClass: "flex-grow-1" }, [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm._f("formatNumber")(
                                      product.quantityAvailable
                                    )
                                  ) +
                                  " " +
                                  _vm._s(
                                    product.productInfo
                                      ? product.productInfo.measureWeight
                                      : ""
                                  ) +
                                  " "
                              ),
                            ]),
                          ],
                          1
                        )
                      }),
                    ],
                    2
                  )
                : _vm._e(),
              _c(
                "infinite-scroll",
                {
                  key: _vm.infiniteScrollKey,
                  attrs: { totalPages: _vm.totalPages },
                  on: {
                    fetchData: _vm.fetchData,
                    "update:totalPages": function ($event) {
                      _vm.totalPages = $event
                    },
                    "update:total-pages": function ($event) {
                      _vm.totalPages = $event
                    },
                  },
                },
                _vm._l(_vm.results, function (row) {
                  return _c(
                    VSheet,
                    {
                      directives: [{ def: Ripple, name: "ripple", rawName: "v-ripple" }],
                      key: row.id,
                      staticClass: "my-2 pa-2",
                      attrs: { elevation: 2 },
                      on: {
                        click: function ($event) {
                          return _vm.viewInventoryDetails(row)
                        },
                      },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "d-flex justify-space-between text-caption mb-4",
                        },
                        [
                          _c("span", [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$vuetify.lang.t("$vuetify.label.id")
                                ) +
                                ": " +
                                _vm._s(row.id)
                            ),
                          ]),
                          _c("span", [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$vuetify.lang.t(
                                    "$vuetify.inventory.documentNo"
                                  )
                                ) +
                                ": " +
                                _vm._s(
                                  row.documentNumber
                                    ? row.documentNumber
                                    : "n/a"
                                )
                            ),
                          ]),
                        ]
                      ),
                      _c("div", { staticClass: "flex-grow-1 text-center" }, [
                        _c("div", { staticClass: "font-weight-light" }, [
                          _vm._v(_vm._s(_vm.translateStatus(row.status))),
                        ]),
                        _c("div", { staticClass: "font-weight-bold ma-2" }, [
                          _vm._v(
                            _vm._s(row.productInfo ? row.productInfo.name : "")
                          ),
                        ]),
                        _c("div", [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm._f("formatNumber")(
                                  (row.quantityAvailable
                                    ? row.quantityAvailable
                                    : row.quantity) - row.reservedQuantity
                                )
                              ) +
                              " " +
                              _vm._s(
                                row.productInfo
                                  ? row.productInfo.measureWeight
                                  : ""
                              ) +
                              " "
                          ),
                        ]),
                        row.reservedQuantity && row.reservedQuantity > 0
                          ? _c("div", { staticClass: "text-caption" }, [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$vuetify.lang.t(
                                      "$vuetify.inventory.reserved"
                                    )
                                  ) +
                                  ": " +
                                  _vm._s(
                                    _vm._f("formatNumber")(row.reservedQuantity)
                                  ) +
                                  " " +
                                  _vm._s(
                                    row.productInfo
                                      ? row.productInfo.measureWeight
                                      : ""
                                  ) +
                                  " "
                              ),
                            ])
                          : _vm._e(),
                      ]),
                      _c(
                        "div",
                        {
                          staticClass:
                            "d-flex justify-space-between mt-4 text-caption",
                        },
                        [
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.$vuetify.lang.t(
                                  "$vuetify.worksheet.location"
                                )
                              ) +
                                ": " +
                                _vm._s(_vm.locationName(row.locationId))
                            ),
                          ]),
                          _c("div", [
                            _vm._v(
                              _vm._s(_vm._f("formatDateYear")(row.stockTime))
                            ),
                          ]),
                        ]
                      ),
                    ]
                  )
                }),
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "d-flex justify-space-between my-5" },
        [
          _c(VBtn, { on: { click: _vm.goBack } }, [
            _vm._v(
              " " + _vm._s(_vm.$vuetify.lang.t("$vuetify.base.back")) + " "
            ),
          ]),
        ],
        1
      ),
      _c(
        VBottomSheet,
        {
          attrs: { scrollable: "" },
          model: {
            value: _vm.showInventoryDetails,
            callback: function ($$v) {
              _vm.showInventoryDetails = $$v
            },
            expression: "showInventoryDetails",
          },
        },
        [
          _c(
            VCard,
            [
              _c(
                VCardTitle,
                { staticClass: "justify-center" },
                [
                  _c(
                    VBtn,
                    {
                      staticClass: "mt-6",
                      attrs: { text: "" },
                      on: {
                        click: function ($event) {
                          _vm.showInventoryDetails = false
                        },
                      },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(_vm.$vuetify.lang.t("$vuetify.close")) +
                          " "
                      ),
                    ]
                  ),
                ],
                1
              ),
              _c(
                VCardText,
                [
                  _c("inventory-details", {
                    key: _vm.selectedInventoryId,
                    on: { updatedLocation: _vm.updateLocation },
                    model: {
                      value: _vm.selectedInventoryId,
                      callback: function ($$v) {
                        _vm.selectedInventoryId = $$v
                      },
                      expression: "selectedInventoryId",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("confirmation-dialog", { ref: "confirm" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }